import ChartBarIcon from '../components/icons/ChartBarIcon';
import FunnelIcon from '../components/icons/FunnelIcon';
import { Link, useParams } from 'react-router-dom';
import { ReactElement } from 'react';
import IconWrapper from '../components/ui/IconWrapper';
import { useTranslate } from 'react-admin';
import { Button } from '@/components/ui/button';

type Props = {
  status: 'noData' | 'noResult';
};

const iconMap: Record<'noData' | 'noResult', ReactElement> = {
  noData: <ChartBarIcon />,
  noResult: <FunnelIcon />,
};

function EmptyState({ status }: Props) {
  const t = useTranslate();
  const { publisherId } = useParams();

  return (
    <div className="flex flex-col items-center justify-center gap-6 p-20 text-center">
      <div className="rounded-xl border border-border bg-muted/20 p-2">
        <IconWrapper>{iconMap[status]}</IconWrapper>
      </div>
      <h4 className="text-2xl font-bold">{t(`empty.state.${status}.title`)}</h4>
      <p className="text-lg text-muted-foreground">
        {t(`empty.state.${status}.description`)}
      </p>
      {status === 'noData' && (
        <Button variant="outline" size="lg" asChild className="mt-2">
          <Link to={`/publisher/${publisherId}/offers`}>
            {t('empty.state.noData.button')}
          </Link>
        </Button>
      )}
    </div>
  );
}

export default EmptyState;
